export const primeSkeleton = {
  container: {
    width: {
      mobile: "85vw",
      tablet: "90vw",
      laptop: "35vw",
    },
    height: {
      mobile: "15.313rem",
      tablet: "11.8rem",
      laptop: "100vh",
    },
    maxHeight: {
      laptop: "40.8rem",
      desktop: "46.5rem",
    },
    maxWidth: {
      laptop: "33.813rem",
    },
    pt: {
      laptop: "1.875rem",
    },
  },
  image: {
    height: "90%",
  },
};
